import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import FormSection from "@my-dld/components/Form/FormSection";
import { IDType, PSDocument, PvtSellLookUp } from "../../../apis/privatesell/enitites";
import { hideLoading, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import { privateSellApi } from "../../../apis/privatesell";
import { LocaleUtil } from "@eres/core";
import Dropzone from "react-dropzone";
import DocumentInputField from "@my-dld/components/Form/DocumentInputField";
import { getImagePreview, getPSDocName, getPSDocType } from "../Component/PropertyPhoto";
import { RVSDocTypes } from "@my-dld/utils/RVSUtils";
import FormRow from "@eres/forms-web/FormRow";
import { ErrorContainer } from "@eres/forms";
import { getMaxPageSize, getNumberOfPage } from "../../../apis/privatesell/api";

interface Prop {
	IdType: IDType;
	Documents?: PSDocument[];
}

interface State {
	errorViews: ErrorContainer;
	Documents: PSDocument[];
}

interface DocumentDetail {
	document: PvtSellLookUp;
	isRequired: boolean;
}

export default class DocInfo extends Component<Prop, State> {
	constructor( props: Prop ) {
		super( props );
		this.state = {
			Documents: [],
			errorViews: {},
		};
	}

	isValid = () => {
		let isValid = true;
		let errorViews: ErrorContainer = {};
		const { Documents } = this.state;
		Documents.map( value => {
			if ( value.fileName === undefined ) {
				let title = LocaleUtil.getLocalValue( value.documentType );
				isValid = false;
				errorViews.title = Strings.required;
			}
		} );
		this.setState( { errorViews: errorViews } );
		return isValid;
	};
	getData = ( state: State = this.state ) => {
		return {
			documents: state?.Documents,
		};
	};

	componentDidMount(): void {
		if ( !this.props.Documents ) this.loadDocument();
	}

	loadDocument() {
		if ( this.props.IdType ) {
			showLoading();
			const apiHandler = ( response: any ) => {
				hideLoading();
				if ( response && response.documents ) {
					this.setState( {
						Documents: response.documents.map( ( doc: DocumentDetail ) => {
							return {
								identity: doc.document.identity,
								documentType: doc.document,
								isRequired: doc.isRequired,
							};
						} ),
					} );
				}
			};
			const exHandler = ( ex: any ) => {
				hideLoading();
			};
			privateSellApi.getDocument( this.props.IdType.Id.toString() ).then( apiHandler ).catch( exHandler );
		}
	}

	render() {
		const { Documents } = this.state;
		return <div className="tender-registration-form">
			<FormSection title={ Strings.upload_buyer_doc }>
				<FormRow>
					{
						Documents && Documents.map( ( value, index ) => {
							let title = LocaleUtil.getLocalValue( value.documentType );
							const maxPages = getNumberOfPage() ?? 1;
							const maxSizeKb = getMaxPageSize() ? ( getMaxPageSize() * 1000 ) : ( 2 * 1024 * 1000 );
							return <div className="col-md-12" key={ "docs_" + index }>
								<Dropzone
									multiple={ maxPages > 1 }
									maxSize={ maxSizeKb }
									onDropRejected={ this.onDropRejected }
									onDrop={ ( files: File[] ) => {
										this.onDrop( value, files );
									} }
									accept={ [ "image/png", "image/jpeg", "application/pdf" ] }>
									{ ( { getRootProps, getInputProps } ) => (
										<DocumentInputField { ...getRootProps() }
										                    dropZoneInputProps={ getInputProps() }
										                    required={ true }
										                    label={ title }
										                    error={ this.state.errorViews ? this.state.errorViews.title : undefined }
										                    isDocsAdded={ value.fileName !== undefined }/>
									) }
								</Dropzone>
								{
									value.fileName &&
									<RenderDoc
										doc={ value } onDelete={ ( identity: PSDocument ) => {
										this.onDelete( identity );
									} }/>
								}
							</div>;
						} )
					}
				</FormRow>
			</FormSection>
		</div>;
	}

	onDropRejected() {
		showErrorMessage( Strings.tabu_file_exceed_size );
	}

	onDelete( identity: PSDocument ) {
		this.setState( {
			Documents: this.state.Documents.map( ( procDoc: PSDocument ) => {
				if ( procDoc.identity === identity.identity ) {
					procDoc.remoteDoc = undefined;
					procDoc.fileName = undefined;
					procDoc.fileSize = undefined;
					procDoc.localFile = undefined;
					procDoc.localData = undefined;
					return procDoc;
				}
				return procDoc;
			} ),
		} );
	}

	private onDrop = ( doc: PSDocument, files: File[] ) => {
		files.filter( x => x.type.startsWith( "image/" ) || x.type.startsWith( "application/pdf" ) )
		.forEach( file => this.addFile( doc, file ) );
	};

	private addFile( upload: PSDocument, file: File ) {
		const reader = new FileReader();
		reader.onload = () => {
			const binaryStr = reader.result;
			const attachedDoc: PSDocument = {
				...upload,
				localFile: file,
				localData: binaryStr as string,
				fileName: file.name,
				fileSize: file.size,
				type: file.type,
			};
			this.setState( {
				errorViews: {},
				Documents: this.state.Documents.map( ( procDoc: PSDocument ) => {
					if ( procDoc.identity === attachedDoc.identity ) {
						return attachedDoc;
					}
					return procDoc;
				} ),
			} );
		};
		reader.readAsDataURL( file );
	}
}

function RenderDoc( props: { doc: PSDocument, onDelete: ( identity: any ) => void } ) {
	const { doc, onDelete } = props;
	let docType = getPSDocType( doc );
	let preview = ( docType === RVSDocTypes.PDF ) ? <i className="far fa-file-pdf"/> : getImagePreview( doc );
	return <div className={ "mb-2 table-responsive" }>
		<table className="table table-bordered table-condensed table-striped table-responsive-sm upload-table">
			<thead>
			<tr>
				<th>{ Strings.file }</th>
				<th>{ Strings.name }</th>
				<th>{ Strings.action }</th>
			</tr>
			</thead>
			<tbody>
			<tr>
				<td>{ preview }</td>
				<td><a
					key={ `ps_doc_${ doc.identity }` }
					onClick={ () => {
						if ( doc.remoteDoc ) window.open( doc.remoteDoc.url );
					} }>
					<i/>{ getPSDocName( doc ) }</a></td>
				<td>
					<button
						className="btn btn-grey" onClick={ () => {
						onDelete( doc );
					} }><i className="far fa-trash-alt"/>{ Strings.delete }
					</button>
				</td>
			</tr>
			</tbody>
		</table>
	</div>;
}
